export default __webpack_public_path__ + "33b2bde.svg";